<template>
  <div>
    <form>
      <div class="row mt-3">
        <div class="col-md-2 col-12"></div>
        <div class="col-md-8 col-12">
          <div class="mt-3">
            <small id="LblSubject">موضوع</small>
            <input  type="text" v-model="WorkTipModel.Subject" 
            class="form-control  mt-1" autocomplete="off" readonly />
          </div>
        </div>
        <div class="col-md-2 col-12"></div>
      </div>

      <div class="row">
        <div class="col-md-2 col-12"></div>
        <div class="col-md-8 col-12">
          <div class="mt-3">
            <small id="LblProblemDescription">شرح مشکل</small>
            <textarea  id="txtSubject" type="text" v-model="WorkTipModel.ProblemDescription"
             class="form-control  mt-1 disabled" autocomplete="off" readonly />
          </div>
        </div>
        <div class="col-md-2 col-12"></div>
      </div>

      <div class="row">
        <div class="col-md-2 col-12"></div>
        <div class="col-md-8 col-12">
          <div class="mt-3">
            <small id="LblSolutionDescription">شرح راه حل</small>
            <textarea id="txtSubject" type="text" v-model="WorkTipModel.SolutionDescription" 
            class="form-control  mt-1" autocomplete="off" readonly/>
          </div>
        </div>
        <div class="col-md-2 col-12"></div>
      </div>

      <div class="row">
        <div class="col-md-2 col-12"></div>
        <div class="col-md-4 col-12">
          <div class="mt-3">
            <small class="d-block">نوع نکته</small>
            <select class="form-control mt-2 disabled" disabled>
              <option selected>{{ WorkTipModel.TipTypeName }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-4 col-12 mt-3">
          <small class="d-block">فایل پیوست</small>
          <div v-if="WorkTipModel.Attachment != null" class="mt-3">
            <a :href="url + WorkTipModel.Attachment" class="text-success" target="_blank">دریافت
            <i class="fas fa-download "></i></a>
          </div>
          <div v-else class="mt-3">
            <p class="text-danger">ندارد</p>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-2 col-12"></div>
        <div class="col-md-8 col-12">
          <div class="d-flex">
            <button class="btn btn-danger p-2 col ml-3" @click.prevent="$store.state.SeenWorkTip = false">بازگشت</button>
            <button class="btn btn-success p-2 col" @click.prevent="showComment()">ثبت نظر</button>
          </div>
        </div>
        <div class="col-md-2 col-12"></div>
      </div>
    </form>

  </div>
</template>

<script>


export default {
  props: ["WorkTipModel"],
  data() {
    return {
      url: this.$cookies.get("URL"),
    };
  },

  mounted(){
    this.selectIdTblWorkTip = this.WorkTipModel.Id
  },
  methods:{
    showComment() {
      this.$emit('showCommnetEmit', this.WorkTipModel)
    },
  }
};
</script>

<style scoped>
textarea {
  resize: none;
  height: 120px !important;
}

</style>
